import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-reviewsSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-reviewsSlider-container'), {
				slidesPerView: 1,
				spaceBetween: 20,
				slideClass: 'b-reviewsSlider-item',
				loop: true,
				watchOverflow: true,
				pagination : {
					el : el.querySelector('.swiper-pagination'),
					clickable: true,
				},
				navigation : {
					nextEl : el.querySelector('.b-moreAction'),
				},
			});
		});
	});
});
